module.exports = __webpack_public_path__ + "static/Graphik-Bold-8a604ed5e935d80f28a6434813ca6ac3.otf";